import { render, staticRenderFns } from "./cpt-dataV-activeRing.vue?vue&type=template&id=70bd719e&scoped=true"
import script from "./cpt-dataV-activeRing.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-activeRing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bd719e",
  null
  
)

export default component.exports